import { Accordion, AccordionDetails, AccordionSummary, CircularProgress, Link, Typography, makeStyles } from '@material-ui/core';
import { ChevronLeft, ChevronRight } from '@material-ui/icons';
import { useStateRef } from '@zennya/web-component-library/src';
import clsx from 'clsx';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import ReactJson from 'react-json-view';

const useStyles = makeStyles(theme => ({
  img: {
    objectFit: "cover",
    width: 'inherit',
  },
  accordionDetails: {
    width: '100%',
  },
  accordionSummary: {
    width: '100%',
  },
  root: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',

  },
  link: {
    cursor: 'pointer',
  }
}));

const LinkedContent = ({
  root,
  parentRoot,
  pushRoot,
  popRoot,
  referenceIndex,
  scrollIntoView = (node) => { },
  onResetScroll = () => { },
}) => {
  const modalRef = useRef(null);

  const [contentLoaded, setContentLoaded, contentLoadedRef] = useStateRef(false);
  const scrollIntoNodeRef = useRef(false);

  const loadImage = image => {
    return new Promise((resolve, reject) => {
      const loadImg = new Image()
      loadImg.src = image?.image_url
      loadImg.onload = () => {
        resolve(image?.image_url)
      }
      loadImg.onerror = err => reject(err)
    })
  }

  const fetchContent = useCallback(
    async () => {
      setContentLoaded(false)
      try {
        await Promise.allSettled(root?.items?.map(item => loadImage(item)))
        setContentLoaded(true)
      } catch (error) {
        console.log('NestedContent.jsx (63) # error', error);
      }
    },
    [root, onResetScroll],
  );
  useEffect(
    () => {
      setContentLoaded(false)
      fetchContent()
    }, [root]
  );

  useEffect(
    () => {
      if (!modalRef.current) return
      const scrollRef = modalRef?.current?.getElementsByClassName(`content-into ${referenceIndex}`)?.[0]
      scrollRef?.scrollIntoView({ behavior: 'instant' });
      const isLoaded = contentLoadedRef.current
      if (isLoaded) {
        if (scrollRef) {
        } else {
          onResetScroll()
        }
      }
    }, [modalRef.current, referenceIndex, contentLoadedRef.current]
  );


  const classes = useStyles();
  const renderHeader = useMemo(
    () => {
      if (!parentRoot) return
      return (
        <Link
          onClick={(e) => {
            e.preventDefault();
            popRoot();
            modalRef.current = null;
            setContentLoaded(false)
          }}
          className={clsx(classes.root, classes.link)}
        >
          <ChevronLeft />
          <img
            className={classes.img}
            src={parentRoot?.items?.[root?.referenceIndex]?.image_url}
          />
        </Link>
      )
    }, [parentRoot, root, classes.root, classes.img, popRoot]
  );
  return (
    <div ref={modalRef}>
      {renderHeader}
      {!contentLoaded && <CircularProgress />}
      {root?.items?.map((item, index) => {
        let clcs = false
        if (item?.linked_content?.items?.length > 0 || item?.external_link_url) {
          clcs = true
        }
        return (
          <Link
            className={clsx(classes.root, clcs && classes.link, `content-into ${index}`)}
            onClick={(e) => {
              e.preventDefault();
              if (item?.linked_content?.items?.length > 0) {
                pushRoot({
                  newRoot: item?.linked_content,
                  referenceIndex: index
                })
              }
              if (item?.external_link_url) {
                window.open(item?.external_link_url, '_blank')
              }
            }}
          >

            {item?.image_url && <img className={classes.img} src={item?.image_url} alt={item?.label} />}
          </Link>
        )
      })
      }
    </div >
  );
}

const NestedContent = ({ root, onResetScroll, onRestoreScroll, saveScrollCoords }) => {
  const classes = useStyles();

  const [rootStack, setRootStack] = useState([root]);
  const [poppedRoot, setPoppedRoot] = useState(null);


  return (
    <div style={{ minHeight: '60vh' }}>
      <LinkedContent
        key={rootStack?.[rootStack?.length - 1]?.id}
        root={rootStack?.[rootStack?.length - 1]}
        parentRoot={rootStack?.[rootStack?.length - 2]}
        referenceIndex={poppedRoot?.referenceIndex}
        pushRoot={({ newRoot, referenceIndex }) => {
          setRootStack([...rootStack, { ...newRoot, referenceIndex }]);
          // saveScrollCoords()
        }}
        popRoot={() => {
          setPoppedRoot(rootStack?.[rootStack?.length - 1]);
          setRootStack(rootStack?.slice(0, rootStack?.length - 1));
          // onRestoreScroll()
        }}
        onResetScroll={() => {
          onResetScroll()
        }}
      />
    </div>
  );
}

export { NestedContent };
